export default {"src":"/_next/static/media/cart.ac6de24b.svg","height":32,"width":33,"blurWidth":0,"blurHeight":0};